/**
 * Grammarly / similar extensions inject `contenteditable` + `style` on anchors before hydrate.
 * Spread on `<a>` nodes that trigger React "Extra attributes from the server" (outer wrappers like `<article suppressHydrationWarning>` do not shield children).
 */
export const HYDRATION_SHIELD_LINK_PROPS = {
  suppressHydrationWarning: true,
  "data-gramm": "false",
  "data-gramm_editor": "false",
  "data-enable-grammarly": "false",
};
